// Date Picker Keys
export const PREVIOUS_7_DAYS = '7d';
export const PREVIOUS_30_DAYS = '30d';
export const PREVIOUS_MONTH = 'pm';
export const PREVIOUS_QUARTER = 'pq';
export const PREVIOUS_YEAR = 'py';
export const QUARTER_TO_DATE = 'qtd';
export const YEAR_TO_DATE = 'ytd';

// Domain Management Table Types
export const DOMAIN_MANAGEMENT_TABLE_TYPE_CLAIMED = 'claimed';
export const DOMAIN_MANAGEMENT_TABLE_TYPE_DISCOVERED = 'discovered';

// Domain Hierarchy
export const DOMAIN_HIERARCHY_PARENT = 'org_domain';
export const DOMAIN_HIERARCHY_SUBDOMAIN = 'child_domain';

// Domain Status
export const DOMAIN_STATUS_UNCLAIMED = 'unclaimed';
export const DOMAIN_STATUS_APPROVED = 'approved';
export const DOMAIN_STATUS_SUPPRESSED = 'suppressed';
export const DOMAIN_STATUS_PENDING = 'pending';

// Email Auth Statuses (DMARC/SPF)
export const AUTH_STATUS_VALID = 'valid';
export const AUTH_STATUS_INVALID = 'invalid';
export const AUTH_STATUS_NO_RECORD = 'no_record';

// Sender Status
export const SENDER_STATUS_ACCEPTED = 'accepted';
export const SENDER_STATUS_REJECTED = 'rejected';
export const SENDER_STATUS_UNDECIDED = 'undecided';

// Request Methods
export const REQUEST_GET = 'get';
export const REQUEST_POST = 'post';
export const REQUEST_PUT = 'put';
export const REQUEST_DELETE = 'delete';

// Session Storage
export const PFPT_EXPERIMENTAL = 'pfpt_experimental';
